// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"c067178a","293":"64d91382","381":"0e977ca1","489":"f4cde5f7","580":"5ed64990","750":"24ab0283"}[chunkId] + ".chunk.js";
};